import React from 'react'
import { TopBar, useGetPayloadSchemaByIdQuery } from 'prove-common'
import { useParams } from 'react-router'
import { AppLogo } from '../app-logo/AppLogo'

export const SchemaScreenTopBar: React.FC = () => {
  const { payloadSchemaId } = useParams()
  const { data: payloadSchema } = useGetPayloadSchemaByIdQuery(
    Number(payloadSchemaId)
  )
  return (
    <TopBar
      logo={<AppLogo />}
      breadcrumbItems={[
        {
          label: 'Hjem',
          to: '/home'
        },
        {
          label: 'Registreringsskjemaer',
          to: '/schemas'
        },
        {
          label: payloadSchema?.name
        }
      ]}
    />
  )
}
